import { Calculator, Wallet, Smartphone } from 'lucide-react'

const items = [
  {
    icon: <Calculator size={22} />,
    title: 'Every calculator, one place',
    body: 'Motor, Health, Fire, Engineering, Personal Accident, Liability, Package Policies, Miscellaneous — all the calculators an agent needs on a single home screen.',
  },
  {
    icon: <Wallet size={22} />,
    title: 'A wallet for every policy',
    body: 'Scan a policy QR or add manually. Search by customer name, policy number, vehicle, or mobile. See what’s expiring this month.',
  },
  {
    icon: <Smartphone size={22} />,
    title: 'Built for your phone',
    body: 'Native apps for iOS and Android. Quick, light, and ready for the field — even on a patchy connection.',
  },
]

export function WhyBimaUncle() {
  return (
    <section className="mx-auto max-w-6xl px-5 py-12 md:py-16">
      <div className="grid gap-4 md:grid-cols-3">
        {items.map((it) => (
          <div key={it.title} className="card">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand/10 text-brand">
              {it.icon}
            </div>
            <h3 className="mt-4 text-lg">{it.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-soft">{it.body}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
